const searchBeeStatuses = {
  none: -1,
  lt30: 0,
  lt51: 1,
  lte100: 2,
  eq100: 3,
};

export default searchBeeStatuses;
